<div class="c-block c-block--bordered">
  <dl class="c-detail__list">
    <dt class="c-detail__list-name">Loan Details</dt>
    <dt class="c-detail__list-title">What's the estimated, or actual, purchase price of the property you're interested in?</dt>
    <dd class="c-detail__list-description">{{PropertyValuation}}</dd>
    <dt class="c-detail__list-title">How much do you want to borrow?</dt>
    <dd class="c-detail__list-description">{{LoanAmount}}</dd>
  </dl>
  @if (showEditButton) {
    <button class="c-button c-button--neutral" type="button" (click)="editButtonClicked()">
      Edit loan details
      <svg class="c-button__icon c-button__icon--right icon-arrow-right" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.06 14.71"><path fill="none" stroke="#2f3432" stroke-miterlimit="10" d="M.35 14.35l7-7-7-7" /></svg>
    </button>
  }
</div>
